// extracted by mini-css-extract-plugin
export default {"container":"zW-z","title":"AW-z","link":"BW-z"};